import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import Transaction from 'modules/common/components/Transaction';
import Taxpayer from 'modules/common/components/Taxpayer';
import TaxTable from 'modules/common/components/TaxTable';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
// import moment from 'moment';
import { convertToNumber } from 'utils/convertToNumber';
import Requirements from 'modules/CDL/individual/components/Requirements';
import PrintIndividualCedula from './PrintIndividualCedula';
// import { computeCedulaInterest } from '../../helpers';
import UpdateModal from '../components/UpdateModal';
// import ViewORModal from '../components/ViewORModal';
// import VerifyReceipt from '../components/VerifyReceipt';
import RegenerateIndividualCedula from './RegenerateIndividualCedula';
import ViewLogsModal from '../components/ViewLogsModal';
import ApplyDiscountModal from '../components/ApplyDiscountModal';
import * as action from '../action';
import * as c from '../constant';

function IndividualContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  tagAsReceived,
  taxpayer,
  onTagAsPrinted,
  taggingAsPrinted,
  assessing,
  receiving,
  startAssessment,
  onApprove,
  onReject,
  // onRollback,
  onCancelApplication,
  onCancelAssessment,
  onRevoke,
  revoking,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_CEDULA = cmsContext.findByType('CEDULA');
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;
  const permissions = getJson('permissions');
  const getAdministrator = getJson('enableProfile');
  const transactionStatus = _.get(
    transactionInfo,
    'attributes.transaction_status'
  );
  const isStartAssessment = _.get(
    transactionInfo,
    'attributes.is_start_assessment'
  );
  const basicAmount = _.get(
    transactionInfo,
    'included.module.attributes.basic_amount_human'
  );
  const totalCedulaAmount = _.get(
    transactionInfo,
    'included.module.attributes.cedula_amount_human'
  );

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  // const taxAmounts = [
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_1')) || 0,
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_2')) || 0,
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_3')) || 0,
  // ];
  // const taxAmountsCdl = [
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_1') || 0),
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_2') || 0),
  //   parseFloat(_.get(taxpayer, 'additional_residence_tax_cedula_3') || 0),
  // ];

  const onPrintCedula = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintIndividualCedula data={data} id={selectedTransaction} />,
      title: 'Print Cedula Individual',
      modalSize: 'modal-md',
    });
  };

  // const computeCedulaInterest = (total, interestRate) => {
  //   const baseInterestRate = interestRate || 0.0;
  //   const currentMonth = moment(
  //     _.get(transactionInfo, 'attributes.created_at')
  //   ).format('MM');

  //   const monthlyInterestRate = +currentMonth * baseInterestRate;

  //   if (currentMonth > 2) {
  //     return {
  //       total: total * monthlyInterestRate + total,
  //       interest: total * monthlyInterestRate,
  //       interest_percentage: monthlyInterestRate,
  //     };
  //   }

  //   return {
  //     total,
  //     interest: 0,
  //     interest_percentage: 0,
  //   };
  // };

  // const totalInd = _.sum(taxAmounts);

  // const totalIndCdl =
  //   _.sum(taxAmountsCdl) + +_.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_BASIC_AMOUNT');

  const serialNo =
    _.get(
      transactionInfo,
      'included.module.attributes.serial_number_complete'
    ) || 0;

  // const totalWithInterest = computeCedulaInterest(
  //   totalIndCdl,
  //   +_.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_BASE_INTEREST_RATE')
  // );

  // const showVerifyReceipt = (status) => {
  //   return ['FOR PAYMENT CONFIRMATION'].includes(status);
  // };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={taxpayer}
          moduleId={data.attributes.module_id}
          transactId={data.id}
          validId={data.attributes.valid_id_to_present}
        />
      ),
      title: 'Update Cedula',
      modalSize: 'modal-lg',
    });
  };

  // const handleViewOR = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <ViewORModal data={transactionInfo} id={selectedTransaction} />,
  //     title: `View OR`,
  //     modalSize: 'modal-lg',
  //   });
  // };

  // const handleVerifyReceipt = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <VerifyReceipt
  //         transactionInfo={transactionInfo}
  //         id={selectedTransaction}
  //       />
  //     ),
  //     title: `Assess Payment Receipt`,
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleRegenerateCedula = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RegenerateIndividualCedula data={data} id={data.id} />,
      title: 'Regenerate Individual Cedula',
      modalSize: 'modal-md',
    });
  };

  const onStartAssessment = () => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to ${
        isStartAssessment ? 'Stop' : 'Start'
      } assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleApprove = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      `Are you sure you want to approve this transaction?`,
      () => {
        onApprove(selectedTransaction, {}, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleReject = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to reject this transaction?',
      (remarks) => {
        onReject(_.get(data, 'id'), { remarks }, () => {
          showTransaction(_.get(data, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // const handleRollback = () => (e) => {
  //   e.preventDefault();

  //   ConfirmAlert(
  //     'Are you sure you want to rollback this transaction?',
  //     (remarks) => {
  //       onRollback(selectedTransaction, { remarks }, () => {
  //         showTransaction(selectedTransaction);
  //       });
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const handleTagAsReceived = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to tag as received this transaction?',
      (remarks) => {
        tagAsReceived(selectedTransaction, { remarks }, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleViewLogs = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewLogsModal id={selectedTransaction} />,
      title: `View Logs`,
      modalSize: 'modal-lg',
    });
  };

  const handleApplyDiscount = () => {
    const amount = _.get(transactionInfo, 'attributes.amount', 0);
    const discount = _.get(transactionInfo, 'attributes.discount', 0);
    const originalAmount = _.get(
      transactionInfo,
      'attributes.original_amount',
      0
    );

    setModal({
      isOpen: true,
      content: (
        <ApplyDiscountModal
          amount={convertToNumber(amount)}
          discount={convertToNumber(discount)}
          originalAmount={convertToNumber(originalAmount)}
          id={_.get(transactionInfo, 'id')}
        />
      ),
      title: Number(_.get(transactionInfo, 'attributes.discount'))
        ? 'Update Discount'
        : 'Apply Discount',
      modalSize: 'modal-md',
    });
  };

  const handleCancelApplication = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to cancel this transaction?',
      (remarks) => {
        onCancelApplication(selectedTransaction, { remarks }, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleCancelAssessment = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to cancel assessment this transaction?',
      (remarks) => {
        onCancelAssessment(selectedTransaction, { remarks }, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleRevokeCedula = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      <div>
        Are you sure you want to{' '}
        {_.get(transactionInfo, 'included.module.attributes.revoked_at')
          ? 'unrevoke'
          : 'revoke'}
        this cedula?
      </div>,
      (remarks) => {
        onRevoke(selectedTransaction, { remarks }, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // eslint-disable-next-line consistent-return
  const checkAdministratorAssessor = () => {
    if (isStartAssessment > 0) {
      return (
        +_.get(getAdministrator, 'id') ===
        +_.get(transactionInfo, 'attributes.start_assess_by')
      );
    }
    if (isStartAssessment === 0) return true;
  };

  const commonRedBtn = 'gen-btn btn btn-danger font-weight-bold';
  const commonBtnClass =
    'gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold';
  const hideOtherTax = _.get(
    CMS_COMPONENTS,
    'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX'
  );
  const taxTableNote = _.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_NOTE');
  const taxableRows = [
    {
      key: 'description_1',
      label: _.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_DESCRIPTION_1'),
      taxableAmount:
        _.get(taxpayer, 'additional_residence_tax_1_human') || '--',
      cedulaAmount:
        _.get(taxpayer, 'additional_residence_tax_cedula_1_human') || '--',
    },
    ...(!hideOtherTax
      ? [
          {
            key: 'description_2',
            label: _.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_DESCRIPTION_2'),
            taxableAmount:
              _.get(taxpayer, 'additional_residence_tax_2_human') || '--',
            cedulaAmount:
              _.get(taxpayer, 'additional_residence_tax_cedula_2_human') ||
              '--',
          },
          {
            key: 'description_3',
            label: _.get(CMS_CEDULA, 'CEDULA_INDIVIDUAL_DESCRIPTION_3'),
            taxableAmount:
              _.get(taxpayer, 'additional_residence_tax_3_human') || '--',
            cedulaAmount:
              _.get(taxpayer, 'additional_residence_tax_cedula_3_human') ||
              '--',
          },
        ]
      : []),
  ];
  const summaryRows = [
    {
      key: 'basic_tax',
      label: 'Basic Tax',
      cedulaAmount: basicAmount,
    },
    {
      key: 'additional_tax',
      label: 'Additional Tax',
      cedulaAmount: totalCedulaAmount,
    },
    {
      key: 'interest',
      label: `Interest (${
        _.get(
          transactionInfo,
          'included.module.attributes.interest_percentage'
        ) || 0.0
      }% )`,
      cedulaAmount:
        _.get(
          transactionInfo,
          'included.module.attributes.interest_amount_human'
        ) || 0.0,
    },
    {
      key: 'discount',
      label: 'Discount',
      cedulaAmount: _.get(transactionInfo, 'attributes.discount') || 0.0,
    },
    {
      key: 'total_amount',
      label: 'Total Amount',
      cedulaAmount: _.get(transactionInfo, 'attributes.amount') || 0.0,
      isTotal: true,
    },
  ];

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {getInitials(
                          `${_.get(taxpayer, 'first_name')} ${_.get(
                            taxpayer,
                            'middle_name'
                          )} ${_.get(taxpayer, 'last_name')}`
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        }`}
                      </h1>
                    </div>
                  </div>

                  {/* ----------- BUTTONS ----------- */}
                  {/* UPPER BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    <button
                      type="button"
                      onClick={handleViewLogs}
                      className={commonBtnClass}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>View Logs</>
                      )}
                    </button>
                  </div>

                  {/* MID BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    {Acl(permissions, ['CEDULA INDIVIDUAL APPLY DISCOUNT']) &&
                    ['FOR CHECKING'].indexOf(transactionStatus) > -1 &&
                    +isStartAssessment === 1 &&
                    checkAdministratorAssessor() ? (
                      <button
                        type="button"
                        onClick={handleApplyDiscount}
                        className={commonBtnClass}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Apply Discount</>
                        )}
                      </button>
                    ) : null}

                    {/* {showVerifyReceipt(transactionStatus) ? (
                      <button
                        onClick={handleVerifyReceipt}
                        className={commonBtnClass}
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    ) : null} */}

                    {['FOR CHECKING'].indexOf(transactionStatus) > -1 &&
                    checkAdministratorAssessor() &&
                    !isStartAssessment ? (
                      <button
                        type="button"
                        onClick={onStartAssessment(transactionInfo)}
                        className={commonBtnClass}
                      >
                        Start Assessment
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL GENERATE']) &&
                    transactionStatus === 'FOR PRINTING' &&
                    serialNo === 0 ? (
                      <button
                        type="button"
                        onClick={onPrintCedula(transactionInfo)}
                        className={commonBtnClass}
                      >
                        Generate Cedula
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL GENERATE']) &&
                    transactionStatus === 'FOR PRINTING' &&
                    !_.isEmpty(serialNo) ? (
                      <button
                        className={commonBtnClass}
                        onClick={handleRegenerateCedula(transactionInfo)}
                        type="button"
                      >
                        Regenerate Cedula
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL REVOKE']) &&
                    ['ISSUED', 'REVOKED'].indexOf(transactionStatus) > -1 ? (
                      <button
                        type="button"
                        onClick={handleRevokeCedula(transactionInfo)}
                        className={commonBtnClass}
                        disabled={revoking}
                      >
                        {_.get(
                          transactionInfo,
                          'included.module.attributes.revoked_at'
                        )
                          ? 'Unrevoked Cedula'
                          : 'Revoke Cedula'}
                      </button>
                    ) : null}

                    {Acl(permissions, [
                      'CEDULA INDIVIDUAL TAG AS FOR PICK-UP',
                    ]) &&
                    transactionStatus === 'FOR PRINTING' &&
                    serialNo !== 0 ? (
                      <button
                        disabled={taggingAsPrinted || assessing}
                        type="button"
                        onClick={onTagAsPrinted(transactionInfo)}
                        className={commonBtnClass}
                      >
                        {taggingAsPrinted || assessing ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Tag as For Pick-up</>
                        )}
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL TAG AS ISSUED']) &&
                    transactionStatus === 'FOR PICK-UP' &&
                    serialNo !== 0 ? (
                      <button
                        disabled={receiving || assessing}
                        type="button"
                        onClick={handleTagAsReceived(transactionInfo)}
                        className={commonBtnClass}
                      >
                        {receiving || assessing ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Tag as Issued</>
                        )}
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL APPROVE']) &&
                    ['FOR CHECKING'].indexOf(transactionStatus) > -1 &&
                    +isStartAssessment === 1 &&
                    checkAdministratorAssessor() ? (
                      <button
                        type="button"
                        onClick={handleApprove(transactionInfo)}
                        className={commonBtnClass}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Approve</>
                        )}
                      </button>
                    ) : null}
                  </div>

                  {/* LOWER BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    {['FOR CHECKING'].indexOf(transactionStatus) > -1 &&
                    checkAdministratorAssessor() &&
                    isStartAssessment ? (
                      <button
                        type="button"
                        onClick={onStartAssessment(transactionInfo)}
                        className={commonRedBtn}
                      >
                        Stop Assessment
                      </button>
                    ) : null}

                    {Acl(permissions, [
                      'CEDULA INDIVIDUAL CANCEL ASSESSMENT',
                    ]) &&
                    ['PENDING', 'FOR RESUBMISSION'].indexOf(transactionStatus) >
                      -1 &&
                    checkAdministratorAssessor() ? (
                      <button
                        type="button"
                        onClick={handleCancelAssessment(transactionInfo)}
                        className={commonRedBtn}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Cancel Assessment</>
                        )}
                      </button>
                    ) : null}

                    {Acl(permissions, ['CEDULA INDIVIDUAL REJECT']) &&
                    ['FOR CHECKING'].indexOf(transactionStatus) > -1 &&
                    +isStartAssessment === 1 &&
                    checkAdministratorAssessor() ? (
                      <button
                        type="button"
                        onClick={handleReject(transactionInfo)}
                        className={commonRedBtn}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Reject</>
                        )}
                      </button>
                    ) : null}

                    {Acl(permissions, [
                      'CEDULA INDIVIDUAL CANCEL ASSESSMENT',
                    ]) && ['FOR CHECKING'].indexOf(transactionStatus) > -1 ? (
                      <button
                        type="button"
                        onClick={handleCancelApplication(transactionInfo)}
                        className={commonRedBtn}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Cancel Application</>
                        )}
                      </button>
                    ) : null}
                  </div>

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Taxpayer</Tab>
                      <Tab>Fees</Tab>
                      <Tab>Requirements</Tab>
                    </TabList>
                    <TabPanel>
                      {/* <TransactionInformation
                        module="cdl"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      /> */}
                      <Transaction
                        module="cdl"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="py-3">
                        <div className="row justify-content-end mr-2">
                          {Acl(permissions, [
                            'VIEW CEDULA INDIVIDUAL EDIT INFORMATION',
                          ]) &&
                          isStartAssessment &&
                          checkAdministratorAssessor() ? (
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={handleEdit(transactionInfo)}
                              className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>Edit Information</>
                              )}
                            </button>
                          ) : null}
                        </div>
                        <Taxpayer
                          taxpayer={taxpayer}
                          transactionInfo={transactionInfo}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3">
                        <TaxTable
                          note={taxTableNote}
                          taxableRows={taxableRows}
                          summaryRows={summaryRows}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <Requirements
                        data={_.get(
                          transactionInfo,
                          'included.requirementFiles'
                        )}
                      />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

IndividualContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  tagAsReceived: PropTypes.instanceOf(Function).isRequired,
  onTagAsPrinted: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taggingAsPrinted: PropTypes.bool.isRequired,
  assessing: PropTypes.bool.isRequired,
  receiving: PropTypes.bool.isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onReject: PropTypes.instanceOf(Function).isRequired,
  // onRollback: PropTypes.instanceOf(Function).isRequired,
  onCancelApplication: PropTypes.instanceOf(Function).isRequired,
  onCancelAssessment: PropTypes.instanceOf(Function).isRequired,
  onRevoke: PropTypes.instanceOf(Function).isRequired,
  revoking: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  taggingAsPrinted: api.loading.indexOf(c.TAG_AS_PRINTED_TRANSACTION) > -1,
  assessing: api.loading.indexOf(c.START_ASSESSMENT) > -1,
  receiving: api.loading.indexOf(c.TAG_AS_RECEIVED) > -1,
  revoking: api.loading.indexOf(c.REVOKE_CEDULA) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(IndividualContent);
